// Serialize tabular data to an RFC-4180 CSV string. Pure; values are raw
// (numbers/dates pass through as their string form, null/undefined -> empty).

function escapeField(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(columns: string[], rows: Record<string, unknown>[]): string {
  const header = columns.map(escapeField).join(",");
  const body = rows.map((row) => columns.map((col) => escapeField(row[col])).join(",")).join("\n");
  return body ? `${header}\n${body}` : header;
}
